import api from './api';

export const getCertificates = () => api.get('/certificates');
export const getCertificate = (id) => api.get(`/certificates/${id}`);
export const verifyCertificate = (number) => api.get(`/certificates/verify/${number}`);
export const downloadCertificate = (id) =>
    api.get(`/certificates/${id}/download`, { responseType: 'blob' });